import { MobileApp } from '../libs/proto/commUnity_pb';

export const communityAppType = MobileApp.STUDENTHOSPITALITYFACTORY;

export const desktopMode = 3;
export const desktopModeURL = '';
